import React, { useEffect, useState } from "react";
import {
  TextField,
} from "@mui/material";

const DescriptionInput = React.memo(({ initialDescription, onBlur ,onValueChange}) => {
  const [description, setDescription] = useState(initialDescription || "");

  useEffect(() => {
    setDescription(initialDescription || "");
  }, [initialDescription]);
  
  return (
    <TextField
      multiline
      minRows={4}
      label="Description"
      color="secondary"
      fullWidth
      className="filter-inputs"
      variant="outlined"
      size="small"
      margin="dense"
      value={description}
      onChange={(e) => {setDescription(e.target.value)}}
      onBlur={() => onBlur(description.trim())}
    />
  );
});

export default DescriptionInput